/** Format a Date as a "YYYY-MM" string (zero-padded month), using local year/month. */
export function toYearMonth(date: Date): string {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  return `${year}-${String(month).padStart(2, "0")}`;
}

/** Parse a "YYYY-MM" string to a Date at the 1st of that month. Returns null if empty or malformed. */
export function fromYearMonth(value: string | null | undefined): Date | null {
  if (!value) {
    return null;
  }
  const match = /^(\d{4})-(\d{2})$/.exec(value);
  if (!match) {
    return null;
  }
  const year = Number(match[1]);
  const month = Number(match[2]);
  if (month < 1 || month > 12) {
    return null;
  }
  return new Date(year, month - 1, 1);
}

/**
 * Last day of the picked month at UTC midnight, the shape Transaction.targetMonth is stored in.
 * Takes the picker's local Date: a local 1 Sep 00:00 in UTC+3 is still 31 Aug in UTC, so the local
 * year and month are what the user meant, and building the result in UTC keeps that month intact on the wire.
 */
export function toTargetMonth(pickedDate: Date): Date {
  return new Date(Date.UTC(pickedDate.getFullYear(), pickedDate.getMonth() + 1, 0));
}

/** The 1st of a stored target month as a local Date, which is what PrimeNG's month view wants to display. */
export function fromTargetMonth(targetMonth: Date): Date {
  return new Date(targetMonth.getUTCFullYear(), targetMonth.getUTCMonth(), 1);
}
